export default __webpack_public_path__ + "static/logo-vertical-white-6ff16d727ee9b5e385c92ce33e31d6ce.svg";